import React from "react";
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-red-200 to-indigo-300 py-8">
      <div className="container mx-auto px-4 flex flex-col lg:flex-row justify-around space-y-8 lg:space-y-0">
        
        {/* Section Grain de Malice */}
        <div className="w-full lg:w-1/4 p-4 lg:p-8">
          <h3 className="text-xl font-semibold mb-4 text-black hover:text-gray-900 text-center">
            Grain de Malice
          </h3>
          <ul className="text-center">
            <li className="my-2">Du lundi au vendredi 7h30 à 18h30</li>
            <li className="my-2">Fermeture annuelle 5 semaines.</li>
          </ul>
        </div>

        {/* Section Adresse */}
        <div className="w-full lg:w-1/4 p-4 lg:p-8">
          <h3 className="text-xl font-semibold mb-4 text-black hover:text-gray-900 text-center">
            Adresse
          </h3>
          <ul className="text-center">
            <li className="my-2">41 Rue Marx Dormoy, 42300 Roanne</li>
          </ul>
          <div className="mt-3 w-full flex flex-col items-center justify-center text-sm text-black">
  <p>&copy; 2026 Grain de Malice.</p>
  <Link to="/mentions-legales" className="text-green-700 hover:underline mt-2">
    Mentions Légales
  </Link>
</div>
        </div>

        {/* Section Contact */}
        <div className="w-full lg:w-1/4 p-4 lg:p-8">
          <h3 className="lg:text-xl text-sm font-semibold mb-4 text-black hover:text-gray-900 text-center">
            Contact
          </h3>
          <ul className="text-center">
            <li className="my-2 ">Tél. : 09 81 65 51 57</li>
            <li>ou 06 69 43 55 26</li>
            <li className="my-2">
              <a href="mailto:microcrecheroanne@gmail.com">
                microcrecheroanne@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>
{/* 
      <div className="w-full flex flex-col items-center justify-center text-sm text-black">
  <p>&copy; 2024 Grain de Malice. Tous droits réservés.</p>
  <Link to="/mentions-legales" className="text-green-700 hover:underline mt-2">
    Mentions Légales
  </Link>
</div> */}


    </footer>
  );
};
